import { render, staticRenderFns } from "./_userId.vue?vue&type=template&id=09765ba4&"
import script from "./_userId.vue?vue&type=script&lang=ts&"
export * from "./_userId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports